import * as z$1 from "zod/v4";
//#region src/schemas/http/identity-image.ts
const IDENTITY_IMAGE_MAX_SIZE_BYTES = 5242880;
const IDENTITY_IMAGE_MAX_DIMENSION = 2e4;
const IDENTITY_IMAGE_MAX_PIXELS = 4e7;
const IDENTITY_IMAGE_OUTPUT_SIZE = 512;
const IDENTITY_IMAGE_OUTPUT_MIME_TYPE = "image/webp";
const identityImageMimeTypeSchema = z$1.enum([
	"image/jpeg",
	"image/png",
	"image/webp"
]);
//#endregion
export { IDENTITY_IMAGE_MAX_DIMENSION, IDENTITY_IMAGE_MAX_PIXELS, IDENTITY_IMAGE_MAX_SIZE_BYTES, IDENTITY_IMAGE_OUTPUT_MIME_TYPE, IDENTITY_IMAGE_OUTPUT_SIZE, identityImageMimeTypeSchema };

//# sourceMappingURL=identity-image.js.map